import { PlazaService } from "../../../services/plaza.service.js";
import { FeedCard } from "./FeedCard.js";
import { locale } from "../../../services/LocaleService.js";

export class PlazaFlow {
    constructor(container) {
        this.container = container;
        this.unsubscribe = null;
    }

    render() {
        const wrapper = document.createElement('div');
        wrapper.className = "w-full overflow-hidden"; // [FIX] Removed py-8

        wrapper.innerHTML = `
            <div class="max-w-7xl mx-auto px-4 mb-4 flex items-center justify-between">
                <h2 class="text-xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent flex items-center gap-2 cursor-pointer" onclick="window.router.navigate('/plaza')">
                    <span class="material-symbols-outlined text-violet-500">auto_awesome</span>
                    ${locale.t('main.realtime_club')}
                </h2>
                <button onclick="window.router.navigate('/plaza')" class="text-sm text-gray-400 hover:text-violet-600 flex items-center gap-1 transition-colors">
                    ${locale.t('main.enter_club')} <span class="material-symbols-outlined text-[16px]">login</span>
                </button>
            </div>
            
            <div class="relative group">
                <div id="plaza-flow-track" class="flex gap-4 overflow-x-auto px-4 pb-4 no-scrollbar scroll-smooth">
                    <div class="flex-shrink-0 w-80 h-40 bg-gray-100 dark:bg-zinc-800 rounded-2xl animate-pulse"></div>
                    <div class="flex-shrink-0 w-80 h-40 bg-gray-100 dark:bg-zinc-800 rounded-2xl animate-pulse" style="animation-delay: 0.1s"></div>
                </div>
            </div>
        `;

        this.container.innerHTML = '';
        this.container.appendChild(wrapper);
        this.track = wrapper.querySelector('#plaza-flow-track');

        this.startListening();
    }

    startListening() {
        if (this.unsubscribe) this.unsubscribe();

        // Subscribe to top 10 feeds
        this.unsubscribe = PlazaService.subscribeFeeds(null, 10, (feeds, error) => {
            if (error) {
                console.error("PlazaFlow Error:", error);
                return;
            }

            if (feeds.length === 0) {
                this.renderEmptyState();
                return;
            }

            this.track.innerHTML = '';
            feeds.forEach((data) => {
                const card = new FeedCard(data.id, data, { isFlow: true }).render();
                this.track.appendChild(card);
            });
        });
    }

    renderEmptyState() {
        this.track.innerHTML = `
            <div class="w-full flex flex-col items-center justify-center text-center py-10 bg-gray-50 dark:bg-zinc-800/50 rounded-2xl border border-dashed border-gray-300 dark:border-zinc-700 cursor-pointer" onclick="window.router.navigate('/plaza')">
                <span class="material-symbols-outlined text-4xl text-violet-300 mb-2">rocket_launch</span>
                <p class="text-gray-500 font-medium">${locale.t('main.be_the_first')}</p>
                <div class="mt-4 px-4 py-2 bg-violet-100 text-violet-700 rounded-full text-sm font-bold hover:bg-violet-200 transition-colors">
                    ${locale.t('main.go_to_plaza')}
                </div>
            </div>
        `;
    }

    destroy() {
        if (this.unsubscribe) this.unsubscribe();
    }
}
